import axios from '@/server/request'

// 公众号对比
export default class api {
    /**
     * 获取企业舆情监测文章列表
     * @param {*} params
     */
    static getOpinionList(params) {
        return axios.post({
            url: '/Fangqisearch/article',
            params
        })
    }

    /**
     * 获取企业舆情文章列表
     * @param {*} params
     */
    static getEnterpriseArticle(params) {
        return axios.get({
            url: '/enterprise/article',
            params
        })
    }

    /**
     * 获取企业详情
     * @param {*} params
     */
    static getEnterpriseDetail(params) {
        return axios.get({
            url: '/enterprise/detail',
            params
        })
    }

    /**
     * 获取股票波动chart表
     * @param {*} params
     */
    static getStock(params) {
        return axios.get({
            url: '/enterprise/stock',
            params
        })
    }

    /**
     * 获取财务数据chart表
     * @param {*} params
     */
    static getFinancial(params) {
        return axios.get({
            url: '/enterprise/financial',
            params
        })
    }

    /**
     * 舆情搜索keyword清洗
     * @param {*} params
     */
    static getOpinionKeyword(params) {
        return axios.get({
            url: '/Fangqisearch/searchFangqiKeyWord',
            params
        })
    }
}
